export default __webpack_public_path__ + "static/media/06-AmazonMusic.3825e73b.png";